export const DATADOG_SITE = 'datadoghq.com';
export const DATADOG_ENVIRONMENTS = {
    // For local development when we test the integrations with datadog, should not be on in general though
    LOCAL: 'local',
    DEV: 'dev',
    SANDBOX: 'sandbox',
    PROD: 'prod',
};
export const DATADOG_LOG_LEVELS = {
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
};
//# sourceMappingURL=constants.js.map